module.exports = __webpack_public_path__ + "static/img/bannerNews.2da787d7.jpg";